import React, { useState, useEffect, useCallback } from "react";
import { Button, InputNumber, message, Row, Col } from "antd";
import ModalCommon from "../../components/Modal";
import { TEXT_DEF } from "../../constant/text";
import {
  VIP_TIER_KEYS,
  VIP_TIER_LABELS,
  DEFAULT_VIP_BONUS_POINTS,
  resolveVipTierFromLevels,
} from "../../constants/vipTiers";
import API, { CONFIG, UPDATE_CONFIG } from "../../network/api";

/** Key API: tỷ lệ quy đổi điểm thưởng (thập phân 0–1, ví dụ 0.53 = 53%) */
const COIN_RATE = "COIN_RATE";

const DEFAULT_PRE_WITHDRAW_ROUNDS = 8;

function pickPreWithdrawRounds(data) {
  const raw =
    data?.multipleReward ??
    data?.multiple ??
    data?.preWithdrawRounds ??
    data?.gameplay?.preWithdrawRounds;
  if (raw === undefined || raw === null || raw === "") {
    return DEFAULT_PRE_WITHDRAW_ROUNDS;
  }
  const n = Number(raw);
  return Number.isFinite(n) ? n : DEFAULT_PRE_WITHDRAW_ROUNDS;
}

const SetupScore = () => {
  const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
  const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  // State lưu dữ liệu hiển thị theo wireframe
  // Format: { [VIP_KEY]: { maxScore: number, percent: number } }
  const [vipConfigData, setVipConfigData] = useState({});

  // Giữ lại config gốc
  const [originalConfig, setOriginalConfig] = useState({});
  const [preWithdrawRounds, setPreWithdrawRounds] = useState(
    DEFAULT_PRE_WITHDRAW_ROUNDS,
  );

  const getDataConfig = useCallback(async () => {
    try {
      const res = await API.get(`${CONFIG}`);
      const data = res.data?.data || res.data;
      setOriginalConfig(data);
      setPreWithdrawRounds(pickPreWithdrawRounds(data));

      const vipLevels = data.vipLevels || {};
      const newVipConfig = {};

      VIP_TIER_KEYS.forEach((key) => {
        const vipData = resolveVipTierFromLevels(vipLevels, key);
        const maxScore =
          vipData?.MAX_SCORE !== undefined && vipData?.MAX_SCORE !== null
            ? Number(vipData.MAX_SCORE)
            : DEFAULT_VIP_BONUS_POINTS[key];

        const rateDecimal = vipData?.[COIN_RATE] || 0;
        const percent = Math.round(rateDecimal * 100);

        newVipConfig[key] = {
          maxScore,
          percent,
        };
      });
      setVipConfigData(newVipConfig);

    } catch (err) {
      console.log(err);
      messageApi.error("Không thể tải dữ liệu cấu hình");
    }
  }, [messageApi]);

  useEffect(() => {
    getDataConfig();
  }, [getDataConfig]);

  const handleUpdateConfig = async () => {
    try {
      setIsShowModalConfirm(false);

      const wager = Number(preWithdrawRounds);
      if (!Number.isFinite(wager) || wager < 0) {
        messageApi.error("Vòng cược trước khi rút phải ≥ 0.");
        return;
      }

      const newVipLevels = {};

      VIP_TIER_KEYS.forEach((key) => {
        const item = vipConfigData[key];
        const existingVipData =
          resolveVipTierFromLevels(originalConfig.vipLevels, key) || {};

        const minScore = existingVipData.MIN_SCORE ?? 0.1;
        const rateDecimal =
          item?.percent > 0 ? Number((item.percent / 100).toFixed(2)) : 0;

        newVipLevels[key] = {
          MAX_SCORE: item?.maxScore || 0,
          MIN_SCORE: minScore,
          [COIN_RATE]: rateDecimal,
        };
      });

      const { gameplay: _omitGameplay, ...configBase } = originalConfig;
      const newConfig = {
        ...configBase,
        vipLevels: newVipLevels,
        multipleReward: wager,
      };

      const body = {
        config: newConfig,
      };

      await API.patch(`${UPDATE_CONFIG}`, body);
      setIsShowModalSuccess(true);

      setTimeout(() => {
        getDataConfig();
      }, 1000);
    } catch (err) {
      console.log(err);
      messageApi.error(err?.response?.data?.message || "Cập nhật thất bại");
      setIsShowModalSuccess(false);
    }
  };

  const handleShowModal = () => setIsShowModalConfirm(true);

  const handleVipChange = (key, field, value) => {
      setVipConfigData(prev => ({
          ...prev,
          [key]: {
              ...prev[key],
              [field]: Number(value) || 0
          }
      }));
  };

  return (
    <div className="col-12" style={{ padding: "20px" }}>
      {contextHolder}

      {/* SECTION MAIN: CẤU HÌNH NHƯ WIREFRAME */}
      <div style={{ marginBottom: "40px", border: "1px solid #d9d9d9", padding: "20px", borderRadius: "8px" }}>
        {/* Cùng khối maxWidth với ô nhập: tiêu đề căn giữa đúng trên cột điểm */}
        <Row gutter={24} style={{ marginBottom: 12 }}>
          <Col xs={0} sm={10} md={8} aria-hidden />
          <Col xs={24} sm={14} md={10}>
            <div
              style={{
                maxWidth: 280,
                width: "100%",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <div
                style={{
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  textAlign: "center",
                  letterSpacing: "0.02em",
                  marginBottom: 4,
                }}
              >
                ĐIỂM THƯỞNG
              </div>
            </div>
          </Col>
        </Row>

        {VIP_TIER_KEYS.map((key) => (
            <Row key={key} gutter={24} style={{ marginBottom: "15px", alignItems: "center" }}>
                <Col xs={24} sm={10} md={8} style={{ fontWeight: 500 }}>
                    {VIP_TIER_LABELS[key] || key}:
                </Col>
                <Col xs={24} sm={14} md={10}>
                    <div
                      style={{
                        maxWidth: 280,
                        width: "100%",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    >
                      <InputNumber
                        style={{ width: "100%" }}
                        min={0}
                        value={vipConfigData[key]?.maxScore}
                        onChange={(val) => handleVipChange(key, 'maxScore', val)}
                        placeholder="Nhập điểm thưởng"
                      />
                    </div>
                </Col>
            </Row>
        ))}

        <Row gutter={24} style={{ marginTop: 24, alignItems: "center" }}>
          <Col xs={24} sm={10} md={8} style={{ fontWeight: 500 }}>
            Vòng cược trước khi rút:
          </Col>
          <Col xs={24} sm={14} md={10}>
            <div
              style={{
                maxWidth: 280,
                width: "100%",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <InputNumber
                style={{ width: "100%" }}
                min={0}
                value={preWithdrawRounds}
                onChange={(val) => setPreWithdrawRounds(Number(val) || 0)}
                placeholder="Nhập số vòng cược"
              />
            </div>
          </Col>
        </Row>

      </div>

      <Button type="primary" style={{ marginTop: 20 }} onClick={handleShowModal}>
        Cập nhật
      </Button>

      {isShowModalConfirm && (
        <ModalCommon
          isShow={isShowModalConfirm}
          message={TEXT_DEF.text0062}
          txtBtnAcc={TEXT_DEF.text0008}
          textBtnClose={TEXT_DEF.text0023}
          actionNext={handleUpdateConfig}
          close={() => setIsShowModalConfirm(false)}
        />
      )}
      {isShowModalSuccess && (
        <ModalCommon
          isShow={isShowModalSuccess}
          message={TEXT_DEF.text0063}
          txtBtnAcc={TEXT_DEF.text0007}
          actionNext={() => {
            setIsShowModalSuccess(false);
            getDataConfig();
          }}
          close={() => {
            setIsShowModalSuccess(false);
            getDataConfig();
          }}
        />
      )}
    </div>
  );
};

export default SetupScore;